import HubertInput from 'components/HubertUI/HubertInput';
import type { ComponentProps } from 'react';
import { useEffect, useState } from 'react';

// @ts-ignore
interface Props extends ComponentProps<typeof HubertInput> {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
}

const DebouncedInput = ({ value: initialValue, onChange, debounce = 500, ...props }: Props) => {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return <HubertInput {...props} value={value} onChange={(e) => setValue(e.target.value)} />;
};

export default DebouncedInput;
